var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyDrAnna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9439 0C15.6793 0 12.2227 3.46354 12.2227 7.74089C12.2227 9.87956 13.0861 11.8131 14.4849 13.2161L16.0817 14.8177V7.74089H23.7996V14.8177L25.3997 13.2161C26.7953 11.8164 27.6618 9.87956 27.6618 7.74089C27.6618 3.46354 24.2053 0 19.9439 0ZM34.4158 0C34.0458 0 33.7245 0.205078 33.5655 0.511068L29.3008 8.56771C29.2814 8.61003 29.2684 8.65885 29.2684 8.71094C29.2684 8.88997 29.4112 9.0332 29.5897 9.0332C29.687 9.0332 29.7779 8.98763 29.8363 8.91276L29.8493 8.89648C29.8493 8.88997 29.8526 8.88997 29.8558 8.88672L35.198 1.52669C35.3083 1.36719 35.3765 1.17839 35.3765 0.966797C35.3797 0.432943 34.9513 0 34.4158 0ZM14.777 16.1296L13.1802 14.5247C11.7846 13.125 9.85349 12.2591 7.72116 12.2591C3.45651 12.2591 0 15.7259 0 19.9967C0 24.2708 3.45651 27.7376 7.71792 27.7376C9.85025 27.7376 11.7813 26.8717 13.1769 25.472L14.7737 23.8704H7.71792V16.1296H14.777Z",
    fill: "#E61565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1994 10.6413C31.2513 10.6413 31.3 10.6315 31.3422 10.6087L39.3717 6.33464C39.6768 6.17187 39.8845 5.85286 39.8845 5.48177C39.8845 4.94466 39.4528 4.51172 38.9173 4.51172C38.7128 4.51172 38.5181 4.57682 38.3623 4.69076L31.0274 10.0521C31.0241 10.0521 31.0209 10.0521 31.0176 10.0553L30.9982 10.0684C30.9268 10.1302 30.8813 10.2181 30.8813 10.3158C30.8781 10.5013 31.0241 10.6413 31.1994 10.6413ZM32.1633 12.2591C30.0342 12.2591 28.1031 13.125 26.7076 14.5247L25.1107 16.1296H32.1633V23.8672H25.1075L26.7043 25.4688C28.0999 26.8685 30.031 27.7344 32.1601 27.7344C36.4247 27.7344 39.8812 24.2708 39.8812 19.9935C39.8845 15.7259 36.428 12.2591 32.1633 12.2591ZM23.7995 25.1758V32.2559H16.0816V25.1758L14.4848 26.7806C13.086 28.1803 12.2227 30.1172 12.2227 32.2559C12.2227 36.5299 15.6792 40 19.9406 40C24.202 40 27.6585 36.5332 27.6585 32.2559C27.6585 30.1204 26.7919 28.1836 25.3963 26.7806L23.7995 25.1758Z",
    fill: "#28B7C6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 8,
    height: 26,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 8,
    height: 26,
    transform: "rotate(90 33 16)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyDrAnna);
export default __webpack_public_path__ + "static/media/logo_only_dr_anna.1a43287f19aa13a9a4962d3287301db7.svg";
export { ForwardRef as ReactComponent };